var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"space-y-6"},_vm._l((_vm.data.lineHeight),function(value,prop){return _c('div',{key:prop},[_c('div',{staticClass:"text-lg mb-2 text-gray-900 dark:text-gray-500",style:({
        lineHeight: value
      })},[_c('p',[_vm._v(_vm._s(_vm.data.typographyExample))]),_c('p',[_vm._v(_vm._s(_vm.data.typographyExample))])]),_c('CanvasBlockLabel',{attrs:{"label":`leading-${prop}`,"value":value}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }